import React from 'react';
import { withStyles } from '@material-ui/core';
import { Typography } from '../Wrappers';

const UserAvatar = ({ classes, theme, color = 'primary', ...props }) => {
  const activityColor =
    color === 'primary' ? { backgroundColor: 'none' } : { backgroundColor: theme.palette[color].main };
  return (
    <div className={classes.avatar} style={activityColor}>
      <Typography className={classes.text}>{props.activity}</Typography>
    </div>
  );
};

const styles = () => ({
  avatar: {
    width: 30,
    height: 30,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
  },
  text: {
    color: 'white',
  },
});

export default withStyles(styles, { withTheme: true })(UserAvatar);
